class ScrollAnimation {
    selector = '.js-animate-on-scroll';

    init() {
        const options = {
            threshold: 0.3,
            rootMargin: "0px",
            root: null
        }

        const callback = function(entries, observer) {
            entries.forEach(entry => {
                const entryAnimationClass = entry.target.dataset.scrollAnimationClass || 'animated';
                const animateAlways = entry.target.dataset.scrollAnimateAlways !== undefined;
                if (entry.isIntersecting){
                  if(!entry.target.classList.contains(entryAnimationClass)) {
                        entry.target.classList.add(entryAnimationClass);
                    }
                }
                else if(animateAlways){
                    entry.target.classList.remove(entryAnimationClass);
                }
            })
        };

        const observer = new IntersectionObserver(callback, options);
        const animatedElements = document.querySelectorAll(this.selector);

        animatedElements.forEach((el) => {
            observer.observe(el);
        })
    }
}

export { ScrollAnimation }